VjsAdmin.UserBulkUploadErrors = (function () {
    const $table = $('#bulk-upload-errors-table');

    const init = function () {
        initBulkUploadErrorsTable();
    };

    const initBulkUploadErrorsTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#bulk-upload-errors-table',
            formatNoMatches() {
                return 'No errors for this bulk upload.';
            },
            idField: 'user_bulk_upload_error_id',
            sortName: 'date_of_error',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            url: `${window.location.href.split('#')[0]}json/`,
            pageList: [5, 10, 20, 50, 100, 200],
            columns: [
                {
                    title: 'Username',
                    field: 'username',
                    align: 'center',
                    valign: 'middle',
                    class: 'status',
                    sortable: true,
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'City',
                    field: 'city',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'State',
                    field: 'state',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Unique Id',
                    field: 'unique_identifier',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Role',
                    field: 'role',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Password',
                    field: 'password',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Grade',
                    field: 'grade',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Graduation Year',
                    field: 'graduation_year',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Role',
                    field: 'role',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Error',
                    field: 'error_message',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Date',
                    field: 'date_of_error',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};

                formattedResult.total = res.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    if (row.role === '') {
                        row.role = 'student';
                    }

                    row.password = `<a href="#" class="click-reveal" data-value="${row.password}"><i class="fa fa-eye" aria-hidden="true"></i></a>`;
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
